'use strict';
var ACC;
ACC.sidepanel = {
    _autoload: [],

    // Add your constants here.
    _constants: {
        ATTRIBUTE_ARIA_HIDDEN: 'aria-hidden',
        ATTRIBUTE_PANEL_TARGET: 'data-panel-target',
        ATTRIBUTE_PANEL_ID: 'data-panel-id',
        ATTRIBUTE_PANEL_PATH: 'data-panel-path',
        ATTRIBUTE_PANEL_TITLE: 'data-panel-title',
        CLASS_BACK: 'back',
        CLASS_BACK_TEXT: 'text',
        CLASS_COMPONENT: 'sidepanel',
        CLASS_COMPONENT_MOBILE: 'tree-navigation-mobile',
        CLASS_COMPONENT_CONTENT: 'content',
        CLASS_COMPONENT_PANEL: 'panel',
        CLASS_LEVEL_ACTIVE: 'active',
        CLASS_LEVEL_DONE: 'done',
        CLASS_LEVEL_READY: 'ready',
        CLASS_MENU_CLOSE: 'mobile-close__icon',
        CLASS_OPEN: 'open',
        CLASS_OVERLAY: 'overlay',
        CLASS_HIDE_ON_DESKTOP: 'u-hide@big-desktop',
        DATA_BACK: 'back',
        DATA_CONTENT: 'content',
        DATA_CONTEXT: 'context',
        DATA_JOURNEY: 'journey',
        DATA_OVERLAY: 'overlay',
        DATA_CLOSE_BTN: 'closeBtn',
        DATA_PANELS: 'panels',
        DATA_STATUS: 'isOpen',
        DATA_TEXT: 'text',
        DATA_TITLE: 'title',
        ROOT: 'root',
        TEXT_KEY_BACK: 'back',
        SLIDE_DISTANCE: '800',
        SELECTORS_MM_MOBILE_CLOSE: '#mobileCloseWrapper .mobile-close__icon, .tree-navigation-mobile > .overlay',
        BURGER_MENU_ICON: $('#mobileMenuActivator')[0]
    },

    _labels: window.i18n && window.i18n.sidePanelLabels || null, // declared in header.tag
    _aria_labels: window.i18n && window.i18n.sidePanelAriaLables || null, // declared in header.tag

    _state: {
        IS_TREE_NAVIGATION: ($('.tree-nav-container').length > 0),
    },

    // Populate on the fly for cached elements such as multiple use jQuery look-ups.
    _cache: {},

    // Create a Side Panel component.
    // @context (Object) Not allowed to use OOP techniques to pass in the original context to allow access to some object specific functions.
    createComponent: function(context) {
        var SP = ACC.sidepanel;
        var c = SP._constants;
        var state = SP._state;
        var cache = SP._cache;
        var $component = $('<div id="mobileMenu" role="dialog" aria-modal="true"></div>');
        var $overlay = SP.createOverlay();
        var $content = SP.createContent();
        var $back = SP.createBackActivator();

        $component.addClass(c.CLASS_COMPONENT + ' ' + c.CLASS_HIDE_ON_DESKTOP);
        $component.addClass(context);

        $component.data(c.DATA_CONTEXT, ACC[context]);
        $component.data(c.DATA_TEXT, {});
        $component.data(c.DATA_OVERLAY, $overlay);
        $component.append($overlay);
        $component.data(c.DATA_CONTENT, $content);
        $component.append($content);

        $component.data(c.DATA_BACK, $back);
        $content.append($back);

        if (state.IS_TREE_NAVIGATION) {
            var $closeBtn = SP.createCloseBtn();

            cache.$globalToolsNav = SP.createGlobalToolsNav();
            $component.addClass(c.CLASS_COMPONENT_MOBILE);
            $component.data(c.DATA_CLOSE_BTN, $closeBtn);
            $content.append($closeBtn);
        } else {
            var $title = SP.createTitle();

            $component.data(c.DATA_TITLE, $title);
            $content.append($title);
        }

        return $component;
    },

    // Creates and returns a new closing button for the component.
    createCloseBtn: function() {
        var labels = ACC.sidepanel && ACC.sidepanel.hasOwnProperty('_labels') ? ACC.sidepanel._labels : null;
        let closeBurgerMenuLabel = "Close Navigation Menu";
        if (labels) {
            closeBurgerMenuLabel = labels['TEXT_CLOSE_BURGER_MENU_NAV'];
        }

        var $closeBtn = $(`<div id="mobileCloseWrapper">
                                <button class="mobile-close__icon" id="mobile-close__icon" aria-label="${closeBurgerMenuLabel}" aria-hidden=true>×</button>
                            </div>`);

        return $closeBtn;
    },

    // Creates and returns global tools nav list.
    createGlobalToolsNav: function() {
        var labels = ACC.sidepanel && ACC.sidepanel.hasOwnProperty('_labels') ? ACC.sidepanel._labels : null;
        var ariaLabels = ACC.sidepanel && ACC.sidepanel.hasOwnProperty('_aria_labels') ? ACC.sidepanel._aria_labels : null;
        var globalToolsMenuAriaLabel = 'Support and services';
        if (ariaLabels && ariaLabels.hasOwnProperty('GLOBAL_TOOLS')) {
            globalToolsMenuAriaLabel = ariaLabels.GLOBAL_TOOLS;
        }
        var $globalToolsNav = $(`<ul class="global-tools" aria-label="${globalToolsMenuAriaLabel}"></ul>`);

        function createSidePanelNavNode(url, icon, label) {
            var contextPath = ACC.config.encodedContextPath;

            return $('<li><a data-menu-icon="' + icon +'" href="'+ contextPath + url +'"><span class="icon-container" aria-hidden="true"><span class="icon ' + icon + '"></span></span><span class="global-tools__item">' + label + '</span></a></li>');
        };

        if (labels) {
            $globalToolsNav.append(
                createSidePanelNavNode('/store-finder', 'icon-store-locator', labels['TEXT_STORE_LOCATOR']),
                createSidePanelNavNode('/customer-service', 'icon-help', labels['TEXT_HELP_ICON']),
                createSidePanelNavNode('/treasure', 'icon-treasure', labels['TEXT_TREASURE']),
                createSidePanelNavNode('/about-us', 'icon-about-us', labels['TEXT_ABOUT_US']),
                createSidePanelNavNode('/delivery-information', 'icon-track-my-order', labels['TEXT_TRACK_MY_ORDER']),
                createSidePanelNavNode('/gift-cards', 'icon-gift-cards', labels['TEXT_GIFT_CARDS'])
            );
        }

        // Track Help Icon
        $(document).ready(function() {
            $('a[data-menu-icon="icon-help"]').click(function() {
                window.ACC.gtm.trackGlobalHeaderIconClick($(this).text());
            });
        });

        return $globalToolsNav;
    },

    // Creates and returns a new overlay for the component.
    createOverlay: function() {
        var SP = ACC.sidepanel;
        var c = SP._constants;
        var $overlay = $('<div></div>');

        $overlay.addClass(c.CLASS_OVERLAY);

        return $overlay;
    },

    // Creates and returns a new content container component content.
    createContent: function() {
        var SP = ACC.sidepanel;
        var c = SP._constants;
        var $content = $('<div></div>');

        $content.addClass(c.CLASS_COMPONENT_CONTENT);

        return $content;
    },

    // Creates a main title element for the new component.
    createTitle: function() {
        return $("<h3 class=\"o-default-menu-nav-bold\"></h3>");
    },

    // Creates and returns a new panel.
    // @name (String) Identifier for panel
    // @parent (String) Identifier for parent panel (e.g. back destination)
    // @$content (jQuery object) Content for panel.
    createPanel: function($content, id, title, path) {
        var SP = ACC.sidepanel;
        var c = SP._constants;
        var $panel = $('<li></li>');

        $panel.addClass(c.CLASS_COMPONENT_PANEL);
        $panel.attr(c.ATTRIBUTE_PANEL_ID, id);
        $panel.attr(c.ATTRIBUTE_PANEL_TITLE, title);
        $panel.attr(c.ATTRIBUTE_PANEL_PATH, path);
        $panel.addClass(c.CLASS_LEVEL_READY);
        $panel.append($content);

        return $panel;
    },

    // Creates a navigational aid to move back through panels.
    createBackActivator: function() {
        var SP = ACC.sidepanel;
        var c = SP._constants;
        var $back = $("<button type=\"button\"></button>");
        var html = "<span class=\"icon icon-left-open-mini\" aria-hidden=\"true\"></span>" +
                   "<span class=\"" + c.CLASS_BACK_TEXT + "\"></span>";

        $back.addClass(c.CLASS_BACK);
        $back.html(html);

        return $back;
    },

    // Make sure new panels are added to component.
    // @$component (jQuery object) The component/container element.
    // @$panels (jQuery object) The actual panel elements.
    setContent: function($component, $panels) {
        var SP = ACC.sidepanel;
        var c = SP._constants;
        $component.data(c.DATA_CONTENT).append($panels);
        $component.data(c.DATA_PANELS, $panels);

        // Last-minute addition to make panel movement easier.
        $panels.wrapAll("<ul class=\"panels\"></ul>");

        // Remove empty DIV.panels elements when this function called more than once
        $('.panels', $component).filter(function() {return this.childNodes.length < 1;}).remove();
        SP.setPanelsHeight();
    },

    // Set the main title element within the component content.
    // @$component (jQuery object) The component/container element.
    // @text (String) Text to add.
    setTitle: function($component, text) {
        var SP = ACC.sidepanel;
        var c = SP._constants;
        var state = SP._state;

        if (!state.IS_TREE_NAVIGATION) {
            $component.data(c.DATA_TITLE).text(text);
        }
    },

    // Sets text from component in a safe way.
    // Returns object containing all text.
    // @$component (jQuery object) The component/container element.
    // @key (String) Text key to use.
    // @value (String) Text value to set.
    setText: function($component, key, value) {
        var SP = ACC.sidepanel;
        var c = SP._constants;
        var text = $component.data(c.DATA_TEXT);

        text[key] = value;
        $component.data(c.DATA_TEXT, text);

        return $component.data(c.DATA_TEXT);
    },

    // Gets text from component in a safe way.
    // Returns text or empty string.
    // @$component (jQuery object) The component/container element.
    // @key (String) Text to retrieve from any stored.
    getText: function($component, key) {
        var SP = ACC.sidepanel;
        var c = SP._constants;
        var text = $component.data(c.DATA_TEXT);
        var value = '';

        if (text.hasOwnProperty(key)) {
            value = text[key];
        }

        return value;
    },

    // Get the previous panel to current one
    // Returns jQuery element for previously visited panel (based on path attribute of current)
    // @$component (jQuery object) The component/container element.
    getPreviousPanel: function($component) {
        var SP = ACC.sidepanel;
        var c = SP._constants;
        var $current = $component.find('.' + c.CLASS_LEVEL_ACTIVE);
        var path = $current.attr(c.ATTRIBUTE_PANEL_PATH) || '';
        var pathSplit = path.split('|');
        var $previous = $();

        // Calculate the previous from currents path attribute.
        // 1. Get rid of last because should be current.
        // 2. Pop the next will either return unknown or the value we want.
        pathSplit.pop();
        if (path.length) {
            $previous = $component.find('[' + c.ATTRIBUTE_PANEL_ID + '=' + pathSplit.pop() + ']');
        }

        return $previous;
    },

    // Add event listeners
    bindComponentEvents: function() {
        var SP = ACC.sidepanel;
        var c = SP._constants;
        var state = SP._state;
        var $component = $('.' + c.CLASS_COMPONENT);

        this.createAccessibilityModalBehaviour('.' + c.CLASS_COMPONENT);

        // Close events.
        $component.on('click', '.' + c.CLASS_OVERLAY, function(e) {
            var $component = $(e.delegateTarget);

            SP.close($component);
        });

        // Add back facility for browse.
        $component.on('click ', '.' + c.CLASS_BACK, function(e) {
            var $component = $(e.delegateTarget);

            SP.back($component);
        });

        // Add back facility for browse.
        $component.on('click ', '.' + c.CLASS_MENU_CLOSE, function(e) {
            var $component = $(e.delegateTarget);

            SP.close($component);
        });

        // Browse controls.
        $component.on('click', '[' + c.ATTRIBUTE_PANEL_TARGET + ']', function(e) {
            var $component = $(e.delegateTarget);
            var $panel = $(e.currentTarget);
            var target = $panel.attr(c.ATTRIBUTE_PANEL_TARGET);
            var title = $panel.attr(c.ATTRIBUTE_PANEL_TITLE);

            if (target) {
                SP.setTitle($component, title);
                SP.updateView($component, target);
            }
        });

        if (state.IS_TREE_NAVIGATION) {
            $(document).on('mobilemenu_close', function() {
                var $component = $(c.CLASS_COMPONENT_MOBILE);

                SP.close($component);
            });
        } else {
            // Add back facility for browse.
            $component.on('click', '.' + c.CLASS_BACK, function(e) {
                var $component = $(e.delegateTarget);

                SP.back($component);
            });
        }

        // Adjust on resize to compensate for mobile > desktop sizes (e.g. on rotate)
        // And when cookie banner is closed.
        $(window).on('resize', function() {
            SP.positionAndSize($component);
        });

        $(document).on('ACC.cookie.policyMessageViewCompensation', function() {
            SP.positionAndSize($component);
        });

        enquire.register('screen and (min-width:769px)', {
            match: function() {
                ACC.global.enableScroll();
            },
            unmatch: function() {
                if ($component.data(c.DATA_STATUS) === 'true') {
                    ACC.global.disableScroll();
                }
            }
        });
    },

    createAccessibilityModalBehaviour: function(selector) {
        var SP = ACC.sidepanel;
        var $component = $(selector);
        var $focusableElements = $component.find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        var firstFocusableElement = $focusableElements.first()[0];
        var lastFocusableElement = $focusableElements.last()[0];

        // Add key events
        $focusableElements.on('keydown', function(e) {

            // Tab
            if (e.key === 'Tab' && e.shiftKey === false) {
                if (e.target === lastFocusableElement) {
                    e.preventDefault();
                    e.stopPropagation();
                    firstFocusableElement.focus();
                }
            }

            // Shift + Tab
            if (e.key === 'Tab' && e.shiftKey === true) {
                if (e.target === firstFocusableElement) {
                    e.preventDefault();
                    e.stopPropagation();
                    lastFocusableElement.focus();
                }
            }

            // Escape Key
            if (e.key === 'Escape') {
                SP.close($component);
            }
        });
    },

    // Make sure we're in an initial state.
    // @$component (jQuery object) The component/container element.
    intialiseState: function($component) {
        var SP = ACC.sidepanel;
        var c = SP._constants;

        // Run through cached level lists and set to ready visual state.
        SP.setPanelsToReadyState($component.data(c.DATA_PANELS));

        // Blank any stored journey.
        $component.data(c.DATA_JOURNEY, new Array()); // reset.

        // Sets initial class and any ARIA stuff to a Web-view safe state.
        $component.attr(c.ATTRIBUTE_ARIA_HIDDEN, 'true');

        // Resetting container height and padding.
        $component.css('height', '');
        $component.css('padding-top', '');
    },

    // Positions and adds class to set passed panels to ready state.
    // @panels (jQuery collection) The panels you want to set as ready.
    setPanelsToReadyState: function($panels) {
        var SP = ACC.sidepanel;
        var c = SP._constants;
        $panels.each(function() {
            var $this = $(this);
            $this.css('left', c.SLIDE_DISTANCE + 'px');
            SP.updatePanelStateClass($this, c.CLASS_LEVEL_READY);
        });
    },

    // Change the CSS class of a panel.
    // @$node (jQuery object) The panel to affect.
    // @state (String) The CSS class to set.
    setPanelViewState: function($node, state) {
        var SP = ACC.sidepanel;
        var c = SP._constants;
        var left = $node.css('left');
        var position = {
            done: '-=' + c.SLIDE_DISTANCE,
            active: '0',
            ready: '+=' + c.SLIDE_DISTANCE
        };
        SP.updatePanelStateClass($node, state);
        SP.slide(position[state], $node);

        // IF conditiion is defensive quickfix for JS error when $node doesn't exist.
        if (left) {
            left.replace('px', '');
            SP.updatePanelStateClass($node, state);
            SP.slide(position[state], $node);
        }
    },

    // Clean current CSS class state values and set to new.
    // $panel (jQuery element) The Panel with Class attribute to adjust.
    // @state (String) State that is used as CSS class name (e.g. "active", "done", "ready")
    updatePanelStateClass: function($node, state) {
        var SP = ACC.sidepanel;
        var c = SP._constants;
        $node.removeClass(c.CLASS_LEVEL_ACTIVE +
            ' ' + c.CLASS_LEVEL_DONE +
            ' ' + c.CLASS_LEVEL_READY);

        $node.addClass(state);
    },

    // Updates the view.
    // @$component (jQuery object) The component/container element.
    // @id (String) data-panel-id
    // With id argument == forward motion.
    // Without id argument == backward.
    updateView: function($component, id) {
        var SP = ACC.sidepanel;
        var c = SP._constants;
        var journey = $component.data(c.DATA_JOURNEY);
        var done, active, ready, $done, $active;

        if (arguments.length > 1) {
            // Forward
            done = journey.slice(-1);
            active = id;
            journey.push(active);

            if (done && done.length) {
                $done = $('[' + c.ATTRIBUTE_PANEL_ID + '="' + done[0] + '"]', $component);
                SP.setPanelViewState($done, c.CLASS_LEVEL_DONE);
            }
        }
        else {
            // Backward
            ready = journey.pop();
            active = journey.slice(-1);

            if (ready) {
                SP.setPanelViewState($('[' + c.ATTRIBUTE_PANEL_ID + '="' + ready + '"]', $component), c.CLASS_LEVEL_READY);
            }
        }

        // Always an active.
        $active = $('[' + c.ATTRIBUTE_PANEL_ID + '="' + active + '"]', $component);

        SP.setTitle($component, $active.attr(c.ATTRIBUTE_PANEL_TITLE));
        SP.setPanelViewState($active, c.CLASS_LEVEL_ACTIVE);
        SP.updateBackActivator($component, $done);
        $component.data(c.DATA_JOURNEY, journey);
        $component.trigger('view_update');
    },

    // Update the back label.
    // @$component (jQuery object) The component/container element.
    // @$previous (jQuery object) The last visible panel.
    updateBackActivator: function($component, $previous) {
        var SP = ACC.sidepanel;
        var c = SP._constants;
        var journey = $component.data(c.DATA_JOURNEY);
        var $back = $component.data(c.DATA_BACK);
        var $text = $back.find('.' + c.CLASS_BACK_TEXT);
        var text = SP.getText($component, c.TEXT_KEY_BACK);

        if ($back && $back.length) {
            $text.text(text);
            $back.show();

            // Hide when on Root.
            if(journey.length === 1 && journey[0] === c.ROOT) {
                $back.hide();
            }
        }

        $component.trigger('update_back_activator');
    },

    // Initialise the component.
    // @$component (jQuery object) The component/container element.
    // @$panels (jQuery collection) The created panels.
    init: function($component, $panels) {
        var SP = ACC.sidepanel;
        $(document.body).append($component);
        SP.setContent($component, $panels);
        SP.reset($component);
    },

    // Reset to original init state.
    // @$component (jQuery object) The component/container element.
    reset: function($component) {
        var SP = ACC.sidepanel;
        var c = SP._constants;
        SP.intialiseState($component);
        SP.updateView($component, c.ROOT);
    },

    // Calculate top and height of component
    // @$component (jQuery object) The component/container element.
    positionAndSize: function($component) {
        var SP = ACC.sidepanel;
        var c = SP._constants;
        var state = SP._state;
        var height = $(document).height(); // 50 = arbitrary number to compensate for inaccuracy
        var cookieMessageHeight = ACC.cookie.getAreaOpenMessageHeight();
        var $content = $component.data(c.DATA_CONTENT);

        // Always reset the height in case anything changed.
        $component.css('padding-top', cookieMessageHeight + 'px');

        if (!state.IS_TREE_NAVIGATION) {
            $component.css('height', height + 'px');
            $content.css('height', (window.innerHeight - cookieMessageHeight) + 'px');
            SP.setPanelsHeight();
        }
    },

    // sets the max-height on the scrollable view within the menu
    setPanelsHeight: function() {
        var SP = ACC.sidepanel;
        var c = SP._constants;
        var CP = ACC.cookie;
        var dataPanels = $('.' + c.DATA_PANELS);
        // 108px =  (Searchboxcomponent(64) + Back button(38) + Heading (46)) - padding of 40
        var maxPanelHeight = (window.innerHeight - (108 + CP.getAreaOpenMessageHeight())) + 'px';
        dataPanels.css('max-height', maxPanelHeight);
    },

    // Used to move both the container and inner panels.
    // @left (String) Animation amount to manipulate left position (e.g. "-=800" or "+=50").
    // @$element (jQuery element) The item to move.
    // @complete (Function) Callback function to run when animate complete.
    // @time time animation, 600 by default
    slide: function(left, $element, complete, time) {
        if (time === null) {
            time = 600;
        }
        $element.stop();
        $element.css({
            'left': left
        });
        complete && complete();
    },

    // Open the Side Panel component
    // @$component (jQuery object) The component/container element.
    // @$action if you need animation or not
    open: function($component,$action) {
        var SP = ACC.sidepanel;
        var c = SP._constants;
        var $content = $component.data(c.DATA_CONTENT);
        var $overlay = $component.data(c.DATA_OVERLAY);
        const close_menu_icon = $('#mobile-close__icon')[0];

        // Used by other scripts to be aware and perform any action required.
        $(document).trigger('ACC.sidepanel.beforeopen');
        $component.data(c.DATA_STATUS, 'true');
        SP.positionAndSize($component);
        $component.addClass(c.CLASS_OPEN);

        //disable scroll on <main> tag to disallow scrolling on mobile in the background, outside the sidepanel mobilemenu.
        ACC.global.disableScrollOnMain(true);

        // discriminate in case you don't need any animation
        if ($action == 'noAnimation') {
            $overlay.fadeIn(0);

            SP.slide('0', $content, function() {
                // Animation complete.
                $component.attr(c.ATTRIBUTE_ARIA_HIDDEN, 'false');
                $component.trigger('open');
                ACC.global.disableScroll();
            }, 0);
        } else {
            $overlay.fadeIn(150);

            SP.slide('0', $content, function() {
                // Animation complete.
                $component.attr(c.ATTRIBUTE_ARIA_HIDDEN, 'false');
                $component.trigger('open');
                ACC.global.disableScroll();
            });
        }

        // ABANDON - ANALYTICS (MOBILE)
        $(ACC.sidepanel._constants.SELECTORS_MM_MOBILE_CLOSE).on('click tap', function() {
            ACC.gtm.trackMegaMenu_Abandon();
        });
        close_menu_icon.setAttribute("aria-hidden", false);
        c.BURGER_MENU_ICON.setAttribute("aria-expanded", true);
    },

    // Close the Side Panel component
    // @$component (jQuery object) The component/container element.
    close: function($component) {
        var SP = ACC.sidepanel;
        var c = SP._constants;
        var $content = $component.data(c.DATA_CONTENT);
        var $overlay = $component.data(c.DATA_OVERLAY);
        const close_menu_icon = $('#mobile-close__icon')[0];

        if ($overlay) {
            $overlay.fadeOut(150);
        }
        SP.slide('-=' + c.SLIDE_DISTANCE, $content, function() {
            // Animation complete.
            // Reset back to initial state.
            // Set as root for next open.
            SP.reset($component);
            $component.trigger('close');
            ACC.autocomplete.mobileSearchClose();
            $component.data(c.DATA_STATUS, 'false');
            $component.removeClass(c.CLASS_OPEN);
            ACC.global.disableScrollOnMain(false);
            $(document).trigger('ACC.sidepanel.afterclose');
            ACC.global.enableScroll();
        });

        // Detach ABANDON - ANALYTICS (MOBILE) handler
        $(ACC.sidepanel._constants.SELECTORS_MM_MOBILE_CLOSE).off('click tap');

        close_menu_icon.setAttribute("aria-hidden", true);
        c.BURGER_MENU_ICON.setAttribute("aria-expanded", false);
        c.BURGER_MENU_ICON.focus();
    },

    // Back to previous panel.
    // @$component (jQuery object) The component/container element.
    back: function($component) {
        var SP = ACC.sidepanel;
        var c = SP._constants;

        // Root should always be first.
        if ( $component.data(c.DATA_JOURNEY).length < 2) {
            SP.close($component);
        } else {
            SP.updateView($component);
        }
        $component.trigger('back');
    }
};
